/* hs-eslint ignored failing-rules */
/* eslint-disable react/display-name */
/* eslint-disable react/prop-types */

// gimme: conversations-inbox-ui 06/10/2020 24a2e66917cc934433dd111db7e06fd02943ca6a
'use es6';

import PropTypes from 'prop-types';
import { PureComponent, Fragment } from 'react';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import UILink from 'UIComponents/link/UILink';
import { getEntryUrlContext, getUrl } from 'conversations-message-history/context-update/operators/contextUpdateGetters';
import { editChatFlowDeepLink } from '../../../urls/editChatFlowDeepLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const propTypes = {
  chatflowId: PropTypes.number.isRequired,
  chatflowName: PropTypes.string,
  message: RecordPropType('ContextUpdateMessage').isRequired
};
class ChatflowContextUpdate extends PureComponent {
  getChatflowLink() {
    const {
      chatflowName,
      chatflowId
    } = this.props;
    return /*#__PURE__*/_jsx(UILink, {
      href: editChatFlowDeepLink({
        chatflowId
      }),
      external: true,
      use: "blue",
      children: chatflowName
    });
  }
  getEntryUrl(entryUrl) {
    const {
      isFacebookChatflow
    } = this.props;
    const url = getUrl(entryUrl);
    const linkLabel = isFacebookChatflow ? /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "conversations-thread-view.threadHistory.context-update-message.facebook.facebookLinkName"
    }) : url;
    const link = /*#__PURE__*/_jsx(UILink, {
      href: url,
      external: true,
      use: "blue",
      truncate: true,
      truncateStringProps: {
        matchContentWidth: true,
        useFlex: false,
        tooltip: false
      },
      children: linkLabel
    });
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "conversations-thread-view.threadHistory.context-update-message.chatflow.chatflowLink",
      options: {
        entryUrl: link
      }
    });
  }
  render() {
    const {
      message,
      chatflowName
    } = this.props;
    const entryUrl = getEntryUrlContext(message);
    let linkText;
    let sourceText = /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: 'conversations-thread-view.threadHistory.context-update-message.unknownSourceMessage'
    }, 'chatflow-source-message');
    if (chatflowName) {
      sourceText = /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: 'conversations-thread-view.threadHistory.context-update-message.chatflow.chatflowSubmission',
        options: {
          chatflow: this.getChatflowLink()
        }
      }, 'chatflow-source-message');
    }
    if (entryUrl) {
      linkText = this.getEntryUrl(entryUrl);
    }
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        children: sourceText
      }), /*#__PURE__*/_jsx("div", {
        children: linkText
      })]
    });
  }
}
ChatflowContextUpdate.propTypes = propTypes;
export default ChatflowContextUpdate;